export default __webpack_public_path__ + "static/media/lock.009bac59.svg";